import ChargerModal from './charger-modal';

export default ChargerModal;
